import { service } from "../../../services";
import { router } from "../../../router";

const user = JSON.parse(localStorage.getItem("user"));

const state = {
  error: null,
  user
};

const mutations = {
  setUser(state, user) {
    state.user = user;
    localStorage.setItem("user", JSON.stringify(user));
    state.loading = false;
  },

  setError(state, error) {
    state.error = error;
  },

  clear(state) {
    state.user = null;
  }
};

const actions = {
  async login({ dispatch, commit }, payload) {
    try {
      await service.login(payload);
      dispatch("fetchUser");
    } catch (err) {
      commit("setError", err.message);
    }
  },

  async signup({ commit }, payload) {
    try {
      await service.signup(payload);
    } catch (e) {
      commit("setError", err.message);
    }
  },

  async fetchUser({ commit }) {
    try {
      const user = await service.get("/users/~");
      commit("setUser", user);
      router.push("/");
    } catch (e) {
      commit("setError", e.message);
    }
  },

  async signout({ commit }) {
    commit("clear");
    await localStorage.removeItem("token");
    await localStorage.removeItem("user");
    await service.logout();
    router.push("/login");
  },

  clear({ commit }) {
    commit("setError", null);
  }
};

export const auth = {
  namespaced: true,
  state,
  actions,
  mutations
};
